module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue2.fbbc49b1.jpg";